import { ICard } from '../types';
import { IApplicationState } from '../../../../types/types';

export const isCardEpic = (
    state: IApplicationState,
    card: ICard
): boolean => {
    return card.subCardIds && card.subCardIds.length > 0;
};
